<template>
  <component :is="type">
    <slot></slot>
  </component>
</template>

<script>
export default {
  name: 'MpdText',
  props: {
    type: {
      type: String,
      validator(value) {
        // 这个值必须匹配下列字符串中的一个
        return ['span', 'pre', 'p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(value)
      },
      default: () => 'span'
    }
  }
}
</script>
